<script>
  import solicitacaoCancelamentoContratoServico from '../../servico';

  export default {
    components: {  },
    props: {
      solicitacao: Object,
      edicao: Boolean
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      preencherDadosContato() {
        let usuario = this.$storage.usuario();

        this.$set(this.solicitacao, 'nomeSolicitante', usuario.nome);
        this.$set(this.solicitacao, 'emailSolicitante', usuario.email);
        this.$set(this.solicitacao, 'telefoneSolicitante', usuario.telefone.substring(0, 20));
      },
      validarDadosSolicitacao() {
        return this.$validator.validateAll();
      },
    },
  }
</script>

<template>
  <div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group" :class="{'has-error': errors.has('dataCancelamento')}">
          <label class="control-label" for="dataCancelamento">Cancelar a partir de</label>

          <input type="text"
                 class="form-control"
                 id="dataCancelamento"
                 v-mascara="'data'"
                 placeholder="    /    /"
                 v-validate="`required|date_format:DD/MM/YYYY`"
                 data-vv-name="dataCancelamento"
                 data-vv-as="data cancelamento"
                 v-model="solicitacao.dataCancelamento">

          <p class="text-danger" v-show="errors.has('dataCancelamento')">{{ errors.first('dataCancelamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group required" :class="{'has-error': errors.has('motivoCancelamento')}">
          <label class="control-label" for="motivoCancelamento">
            Motivo cancelamento
          </label>

          <textarea class="form-control"
                    id="motivoCancelamento"
                    v-validate="'required'"
                    data-vv-name="motivoCancelamento"
                    data-vv-as="motivo cancelamento"
                    v-model="solicitacao.motivoCancelamento">
          </textarea>

          <p class="text-danger" v-show="errors.has('motivoCancelamento')">{{ errors.first('motivoCancelamento') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-xs btn-success" @click="preencherDadosContato">
            <i class="fa fa-user-circle"></i> Clique aqui para preencher com os seus dados
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('nomeSolicitante')}">
          <label class="control-label" for="nome-solicitante">Nome</label>

          <input type="text"
                 class="form-control"
                 id="nome-solicitante"
                 data-vv-name="nomeSolicitante"
                 v-model="solicitacao.nomeSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="nome"
                 maxlength="100">

          <p class="text-danger" v-show="errors.has('nomeSolicitante')">{{ errors.first('nomeSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="form-group required" :class="{'has-error': errors.has('emailSolicitante')}">
          <label class="control-label" for="email-solicitante">E-mail</label>

          <input type="text"
                 class="form-control"
                 id="email-solicitante"
                 data-vv-name="emailSolicitante"
                 v-model="solicitacao.emailSolicitante"
                 v-validate="`required|emailcomposto`"
                 data-vv-as="e-mail"
                 maxlength="300">

          <p class="text-danger" v-show="errors.has('emailSolicitante')">{{ errors.first('emailSolicitante') }}</p>
        </div>
      </div>
      <div class="col-sm-2">
        <div class="form-group required" :class="{'has-error': errors.has('telefoneSolicitante')}">
          <label class="control-label" for="telefone-solicitante">Telefone</label>

          <input type="text"
                 class="form-control"
                 id="telefone-solicitante"
                 data-vv-name="telefoneSolicitante"
                 v-model="solicitacao.telefoneSolicitante"
                 v-validate
                 data-vv-rules="required"
                 data-vv-as="telefone"
                 v-mascara="'telefone'">

          <p class="text-danger" v-show="errors.has('telefoneSolicitante')">{{ errors.first('telefoneSolicitante') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-cancelamento-contrato/componentes/compartilhado/FormDadosSolicitacao.vue